import BulkDeletePositions from './BulkDeletePositions';

export default BulkDeletePositions;
